import React from "react";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";

import LockIcon from "@material-ui/icons/Lock";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

import { Button, Typography } from "@material-ui/core";

import SvgI24Details from "assets/icons/I24Details";
import SvgI24Menu from "assets/icons/I24Menu";

import PublishStatus from "components/PublishStatus";
import TrimmedText from "components/TrimmedText";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
  MenuContent,
  MenuContentWrapper,
  Menu,
} from "./styles";

type Props = {
  title: string;
  image: string;
  publishStatus: string;
  onDetailsClick: () => void;
  onRemove: () => void;
  onAccessClick?: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  isDragging?: boolean;
};

class CategoryDetailsCard extends React.Component<Props> {
  render() {
    const {
      title,
      image,
      publishStatus,
      onAccessClick,
      onDetailsClick,
      onRemove,
      dragHandleProps,
      isDragging,
    } = this.props;

    return (
      <Container isDragging={isDragging}>
        <ImageContainer image={image} />
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h3" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
          </TextContainer>
          <BottomControlsContainer>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Details />}
                variant="text"
                color="secondary"
                onClick={onDetailsClick}
              >
                Details
              </Button>
            </ControlWrapper>
            {onAccessClick && (
              <ControlWrapper>
                <Button
                  startIcon={<LockIcon />}
                  variant="text"
                  color="secondary"
                  onClick={onAccessClick}
                >
                  Access
                </Button>
              </ControlWrapper>
            )}
            <ControlWrapper>
              <Button
                startIcon={<RemoveCircleOutlineIcon />}
                variant="text"
                color="secondary"
                onClick={onRemove}
              >
                Remove
              </Button>
            </ControlWrapper>
          </BottomControlsContainer>
        </DetailsContainer>

        <MenuContent isDraggable={!!dragHandleProps}>
          <MenuContentWrapper>
            <PublishStatus status={publishStatus} />
          </MenuContentWrapper>
          {dragHandleProps && (
            <MenuContentWrapper>
              <Menu {...dragHandleProps}>
                <SvgI24Menu />
              </Menu>
            </MenuContentWrapper>
          )}
        </MenuContent>
      </Container>
    );
  }
}

export default CategoryDetailsCard;
